import React, { useEffect } from 'react';
import '../../styles/ModalBackdrop.scss';

export interface Props {
  children: any;
  duration: number;
  state: string;
}

export const ModalBackdrop = ({ children, duration, state }: Props) => {
  const defaultStyle = {
    transition: `background-color ${duration}ms ease-in-out, z-index ${duration}ms ease-in-out`,
    backgroundColor: 'rgba(0, 0, 0, 0)',
    zIndex: -1000,
  };

  const transitionStyles = {
    entering: { backgroundColor: 'rgba(0, 0, 0, 0)', zIndex: -1000 },
    entered: { backgroundColor: 'rgba(0, 0, 0, 0.3)', zIndex: 10000 },
  };

  useEffect(() => {
    if (state === 'entered') {
      document.body.classList.add('no-scroll-backdrop');
    } else {
      document.body.classList.remove('no-scroll-backdrop');
    }
  }, [state]);

  return (
    <div
      className='modal-backdrop'
      style={{
        ...defaultStyle,
        ...transitionStyles[state],
      }}
    >
      {children}
    </div>
  );
};
